import BApp from "../../modules/BApp";
import BRequest from "../../modules/BRequest";
import BChart from "../Modules/BChart";
import JPMeasurementChart from "../fo2026/JPMeasurementChart";

export default class BMeasurements
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.profile-measurements`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			const selector = `.profile-diary-day-measurements__delete-button`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				const button = event.target.closest(selector);
				const measurements = new this(button.closest(this.selector()));
				const url = button.dataset.url;
				const data = {
					date: button.dataset.date,
					domain: button.dataset.domain,
					page: measurements.getPage(),
				}

				BRequest.delete(url, data).then(response => {
					new this(document.querySelector(this.selector())).setFromResponse(response);
				}).finally(() => {
					BApp.refresh();
				});
			}
		});
	}

	getPage()
	{
		return parseInt(this.el.dataset.page) || 1;
	}

	setFromResponse(response)
	{
		if (response.data?.redirectUrl) {
			document.location.href = response.data.redirectUrl;
		} else {
			this.setHtml(response.data.templates.content);
		}
	}

	setHtml(html)
	{
		this.el.innerHTML = html;
		BChart.initialize();
		JPMeasurementChart.initialize(this.el);
	}
}
